import moment from 'moment'
import React, { Component } from 'react'

export default class WebFooter extends Component {
  render() {
    if(process.env.REACT_APP_NETWELLUSER == "true")
    return (
      <div class="webfooterdesktop">
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '95%' }}>
          <span> Copyright © {moment().format("YYYY")} netWell. All rights reserved. | Powered by CarynHealth.com</span>
        </div>
        <div>Version 1.1.0</div>
      </div>
    )
    else
    return (
      <div class="webfooterdesktop">
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '95%' }}>
          <span>Copyright © {moment().format("YYYY")} Universal Health Fellowship. All rights reserved. | Powered by CarynHealth</span>
        </div>
        <div>Version 4.2.1</div>
      </div>
    )
  }
}
